<nav #tabNavigation
     class="flex flex-row gap-7 border-b border-grey-light">
  <button *ngFor="let item of tabItems"
          (click)="activate(item)"
          class="text-xs font-extrabold border-b-2 border-transparent pb-2"
          [class.text-primary]="item.active"
          [class.text-grey-dark]="!item.active"
          [class.border-primary]="item.active"
         >
    {{ item.title }}
  </button>
</nav>
<section #tabContents
         class="mt-4">
  <ng-content></ng-content>
</section>
